module.exports = __webpack_public_path__ + "Bliss2.496be792e3c5b802f432.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2.woff
// module id = ../../../../../src/assets/layout/fonts/Bliss2.woff
// module chunks = styles